/**
 * Textos de Compres (`ca`): tall «devolucions» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const devolucionsCa = {
  // Lot retornat, retorn immediat i observacions de la devolució (OBR-117, fitxa QA del 19/10).
  'backoffice.returnedLots': {
    lotStatusReturned: 'Retornat',
    immediateChip: 'Retorn immediat',
    immediateCardNote:
      'El transportista se l’ha emportat en el moment: l’entrada de la recepció i la sortida d’aquesta devolució es compensen, i aquesta quantitat no queda a les existències.',
    immediateMovementNote:
      'Un retorn immediat deixa, al mateix lot, l’entrada de la recepció i la sortida de la devolució: el que torna no es queda a les existències. Els moviments no s’editen; per això hi veus els dos.',
    movementReturnNumber: 'Albarà de devolució {{number}}',
    createErrorObservationsTooLong: 'Les observacions són massa llargues (màxim {{max}} caràcters).',
    rejectObservationsLabel: 'Observacions (opcional)',
    rejectObservationsHint: 'S’afegeixen a cada devolució que es crea, a banda del motiu.',
  },
} as const;
